import React from 'react';
import { AirplaneAnimation } from './airplane_animation';

export function LandingPage() {
  return <AirplaneAnimation/>;
}
